const map = {
	"./211021_0.JPG": 1991,
	"./211021_1.JPG": 8154,
	"./211021_2.JPG": 6325,
	"./211021_3.JPG": 1672,
	"./211021_4.JPG": 8203,
	"./211021_5.JPG": 1518,
	"./211021_6.JPG": 3273,
	"./211021_7.JPG": 5420,
	"./211021_8.JPG": 2495
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7639;